import { generatePath } from "react-router-dom";
import { updateCookie } from "./common";
import { routeURLs } from "./enums";
import { getVManageMonitorUrl } from "./vManageNavigation";

export const getParamKeys = (urlParams, BASE_URL) => {
    let paramKeys = [];
    urlParams.keys().forEach(item => {
        if (item !== `${BASE_URL}/`) {
            paramKeys.push(item);
        }
    })
    return paramKeys;
}

//site id set in site dropdown 
export const deepLinkSetSiteIdDropdown = (urlParams, props, isUIconvergence) => {
    const siteId = urlParams.get('site');
    if (isUIconvergence && urlParams.size === 2) {
        // If convergance is enabled, we need to update the cookie with the siteId and redirect to the manage site overview page
        updateCookie("currentSite", siteId);
        window.location.href = getVManageMonitorUrl("/overview");
    }
    else {
        // If convergance is not enabled, we need to redirect to the vanalytics overview page with the siteId selected
        if (siteId !== null) {
            props.setSelectedSite(siteId);
        }
    }
}

// only time filter send from response
export const deepLinkRedirectToOverview = navigate => {
    navigate(routeURLs.overview);
}

// Insights link redirect to tab
export const deepLinkRedirectToTab = (urlParams, BASE_URL, navigate) => {
    const tabName = urlParams.get('tab');
    if (tabName !== null) {
        const path = {
            anomalydetection: routeURLs.ad,
            bandwidthforecasting: routeURLs.bwf
        }[tabName] || `${BASE_URL}/${tabName}`;
        navigate(path);
    }
}

// Insights link redirect to app360
export const deepLinkRedirectToApp360 = (urlParams, navigate, props, isUIconvergence) => {
    const applicationName = urlParams.get('application');
    if (applicationName !== null) {
        deepLinkSetSiteIdDropdown(urlParams, props, isUIconvergence);
        navigate(generatePath(routeURLs.app360, { appName: applicationName }));
    }
}

export const getCircuit360Keys = () => {
    return ['device_id', 'color', 'device_host_name', 'bandwidth_downstream', 'bandwidth_upstream', 'site']
}

// Insights link redirect to circuit 360
/********set circuit name redirect to circuit 360 url */
export const deepLinkRedirectToCircuit360 = (urlParams, navigate, props, isUIconvergence) => {
    const device_id = urlParams.get('device_id');
    const local_color = urlParams.get('color');
    const device_host_name = urlParams.get('device_host_name');
    const bandwidth_downstream = urlParams.get('bandwidth_downstream');
    const bandwidth_upstream = urlParams.get('bandwidth_upstream');

    if (device_host_name !== null) {
        const circuitNameRedirect = `${device_host_name}~${local_color}`;
        const circuitDisName = `${device_host_name}: ${local_color}`;
        const circuitName = `${device_id}: ${local_color}`;
        const siteId = urlParams.get('site');
        const circuit = {
            vdevice_id: device_id,
            color: local_color,
            device_host_name: device_host_name,
            circuit_display_name: circuitDisName,
            circuit_name: circuitName,
            bandwidth_downstream: bandwidth_downstream,
            bandwidth_upstream: bandwidth_upstream,
            site_id: parseInt(siteId)
        }
        localStorage.setItem(
            "circuit360Data",
            JSON.stringify({
                ...circuit,
                overlay: localStorage.getItem("currentOverlay")
            })
        );
        deepLinkSetSiteIdDropdown(urlParams, props, isUIconvergence);
        navigate(generatePath(routeURLs.circuit360, { circuitName: circuitNameRedirect }));
    }
}
